<div class="widget-body border-box border-lighter-gray business-tools-widget background-white col-xs-12">
  <div class="row">
    <div class="widget-button-container col-sm-7 col-xs-12">
      <button class="btn background-green full-width no-radius color-white" (click)="goToPage('/business-tools')">Find
        out more</button>
    </div>
  </div>
</div>